

































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import { AppModule } from '@/store/modules/app';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import AgencyUserGeneralDetailsEdit from '@/components/AgencyUsers/AgencyUserGeneralDetailsEdit.vue';
import AgencyUserAvatarEdit from '@/components/AgencyUsers/AgencyUserAvatarEdit.vue';
import AgencyUserRolesEdit from '@/components/AgencyUsers/AgencyUserRolesEdit.vue';
import Alert from '@/components/Shared/Alert.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import AgencyUserStatusDisplay from '@/components/AgencyUsers/Display/AgencyUserStatus.vue';
import AgencyUserStatusEnum from '@/models/AgencyUsers/AgencyUserStatus';
import IdentityProvider from '@/models/Users/IdentityProvider';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import UpdateAgencyUserStatusRequest from '@/models/AgencyUsers/UpdateAgencyUserStatusRequest';
import PageNames from '@/router/PageNames';

@Component({
    name: 'AgencyUserDetail',
    components: { AgencyUserGeneralDetailsEdit, AgencyUserAvatarEdit, AgencyUserRolesEdit, AgencyUserStatusDisplay, Alert }
})
export default class extends GiganautVue {

    AgencyUserStatus = AgencyUserStatusEnum;
    FirebaseEmailPassword = IdentityProvider.FirebaseEmailPassword;

    async created() {
        if (this.currentAgencyUser) {
            AgencySettingsModule.getAgencyRolesForUser(this.currentAgencyUser.id);
        }
    }

    get loading() {
        return AgencySettingsModule.loadingAgencyUsers;
    }

    get currentAgencyUser() {
        return AgencySettingsModule.currentAgencyUser;
    }

    get currentUserAgencyRoles() {
        return AgencySettingsModule.currentUserAgencyRoles;
    }

    get currentUserAvatarUrl() {
        return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/2/" + this.currentAgencyUser.id + "/" + this.currentAgencyUser.avatar;
    }

    get currentUserAvatarThumbnailUrl() {
        return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/2/" + this.currentAgencyUser.id + "/resized-100/" + this.currentAgencyUser.avatar;
    }

    getManagerAvatarUrl() {
        const manager = this.currentAgencyUser.manager;
        return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/2/" + manager.id + "/resized-100/" + manager.avatar;
    }

    get branchName() {
        if (this.currentAgencyUser.defaultBranch == null) return '';
        return this.currentAgencyUser.defaultBranch.brandName;
    }

    get deskName() {
        if (this.currentAgencyUser.defaultDesk == null) return '';
        return this.currentAgencyUser.defaultDesk.name;
    }

    get aggregatePermissionRows() {
        const permissionFields = [
            { label: 'Workers', field: 'permissionWorkers' },
            { label: 'Companies', field: 'permissionCompanies' },
            { label: 'Locations', field: 'permissionLocations' },
            { label: 'Contacts', field: 'permissionContacts' },
            { label: 'Bookings', field: 'permissionBookings' },
            { label: 'Jobs', field: 'permissionJobs' },
            { label: 'Spec Outs', field: 'permissionSpecOuts' },
            { label: 'Invoices', field: 'permissionInvoices' },
            { label: 'Timesheets', field: 'permissionTimesheets' },
            { label: 'Campaigns', field: 'permissionCampaigns' },
            { label: 'Messaging', field: 'permissionMessaging' },
            { label: 'Reports', field: 'permissionReports' },
            { label: 'Activities', field: 'permissionActivities' },
            { label: 'Compliance', field: 'permissionCompliance' },
            { label: 'KPIs', field: 'permissionKpis' },
            // Agency section
            { label: 'Settings: Agency Profile', field: 'permissionSettingsAgencyProfile' },
            { label: 'Settings: Branches', field: 'permissionSettingsBranches' },
            { label: 'Settings: Rate Cards', field: 'permissionSettingsRateCards' },
            { label: 'Settings: Uniforms', field: 'permissionSettingsUniforms' },
            { label: 'Settings: Reporting Periods', field: 'permissionSettingsReportingPeriods' },
            { label: 'Settings: KPIs', field: 'permissionSettingsKpis' },
            // Users & Permissions section
            { label: 'Settings: Users', field: 'permissionSettingsUsers' },
            { label: 'Settings: Groups', field: 'permissionSettingsGroups' },
            { label: 'Settings: Roles', field: 'permissionSettingsRoles' },
            // Communication section
            { label: 'Settings: Email Templates', field: 'permissionSettingsEmailTemplates' },
            { label: 'Settings: Conversation Topics', field: 'permissionSettingsConversationTopics' },
            { label: 'Settings: Business Hours', field: 'permissionSettingsBusinessHours' },
            // Categories section
            { label: 'Settings: Note Categories', field: 'permissionSettingsNoteCategories' },
            { label: 'Settings: Activity Categories', field: 'permissionSettingsActivityCategories' },
            // Work Types section
            { label: 'Settings: Industries', field: 'permissionSettingsIndustries' },
            { label: 'Settings: Location Types', field: 'permissionSettingsLocationTypes' },
            { label: 'Settings: Skills', field: 'permissionSettingsSkills' },
            { label: 'Settings: Qualifications', field: 'permissionSettingsQualifications' },
            { label: 'Settings: Positions', field: 'permissionSettingsPositions' },
            // Integrations section
            { label: 'Settings: Integrations', field: 'permissionSettingsIntegrations' },
            { label: 'Settings: Mobile App', field: 'permissionSettingsMobileApp' },
        ];

        if (this.currentAgencyUser.isAdministrator) {
            return permissionFields.map(p => ({ label: p.label, value: 2 }));
        }

        const roles = this.currentUserAgencyRoles;
        return permissionFields.map(p => ({
            label: p.label,
            value: roles.length > 0 ? Math.max(...roles.map((r: any) => r[p.field] || 0)) : 0,
        }));
    }

    permissionLevelText(level: number): string {
        switch (level) {
            case 1: return 'View';
            case 2: return 'Manage';
            default: return 'None';
        }
    }

    navigateToUserList() {
        this.$router.push({ name: PageNames.AgencyUserSettings });
    }

    async migrateUser() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "MIGRATE",
            buttonFalseText: "CANCEL",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to migrate the user to Firebase?', options);
        if (result) {
            await AgencySettingsModule.migrateAgencyUser(this.currentAgencyUser.userId);
        }
    }

    async triggerPasswordReset() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "SEND",
            buttonFalseText: "CANCEL",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to send a password reset link to ' + this.currentAgencyUser.emailAddress + '?', options);
        if (result) {
            await AgencySettingsModule.triggerPasswordReset(this.currentAgencyUser.userId);
        }
    }

    async deleteAgencyUser() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "DELETE",
            buttonFalseText: "CANCEL",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete the user ' + this.currentAgencyUser.person.firstName + ' ' + this.currentAgencyUser.person.lastName + '?', options);
        if (result) {
            const request = new UpdateAgencyUserStatusRequest();
            request.updatedAt = this.currentAgencyUser.updatedAt;
            request.status = AgencyUserStatusEnum.Deleted;
            await AgencySettingsModule.deleteAgencyUser(request);
        }
    }
}
